import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { db } from '../firebase/config';
import { doc, setDoc } from 'firebase/firestore';
import { useAuth } from './AuthContext';

export const LIGHT = {
  bg: '#f5f2ec',
  card: '#ffffff',
  cardSolid: '#ffffff',
  border: 'rgba(26,21,16,0.07)',
  text: '#1a1510',
  textSec: '#6b5e52',
  sub: '#9c8e82',
  primary: '#c8973a',
  accent: '#c8973a',
  gold: '#c8973a',
};

export const DARK = {
  bg: '#111008',
  card: 'rgba(26,22,14,0.98)',
  cardSolid: '#1a1610',
  border: 'rgba(244,241,234,0.07)',
  text: '#f0e8da',
  textSec: '#b8a896',
  sub: '#7a6e62',
  primary: '#c8973a',
  accent: '#c8973a',
  gold: '#c8973a',
};

const DarkModeContext = createContext({ isDark: true, toggle: () => {}, colors: DARK });

export function DarkModeProvider({ children }) {
  const { user } = useAuth();
  const [isDark, setIsDark] = useState(true);

  // Apply class to body whenever isDark changes
  useEffect(() => {
    document.body.classList.toggle('dark-mode', isDark);
  }, [isDark]);

  const toggle = useCallback(async () => {
    const next = !isDark;
    setIsDark(next);
    localStorage.setItem('learnable_dark', String(next));
    if (user) {
      try {
        await setDoc(doc(db, 'userProfile', user.uid), { darkMode: next }, { merge: true });
      } catch (_) {}
    }
  }, [isDark, user]);

  return (
    <DarkModeContext.Provider value={{ isDark, toggle, colors: isDark ? DARK : LIGHT }}>
      {children}
    </DarkModeContext.Provider>
  );
}

export function useDarkMode() {
  return useContext(DarkModeContext);
}
